export default "__VITE_ASSET__DIfhPh5$__"